import { useState } from "react";

type TTimer = ReturnType<typeof setTimeout>;

interface IUseTaskPollArgs {
  poll: () => string | Promise<string>;
  query: () => string | Promise<string>;
  interval?: number;
}

export function useTaskPoll(args: IUseTaskPollArgs) {
  const { poll, query, interval = 2000 } = args;
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState();
  const [timeoutHandle, setTimeoutHandle] = useState<TTimer>();

  async function pollServer() {
    const response = await poll();
    if (response == "running") {
      setTimeoutHandle(setTimeout(pollServer, interval));
    } else {
      try {
        if (response == "success") {
          await queryContent();
        }
      } finally {
        console.debug(timeoutHandle);
        setLoading(false);
      }
    }
  }

  async function queryContent() {
    const response = await query();
    setContent(response);
  }

  async function taskPoll() {
    setLoading(true);
    setTimeoutHandle(setTimeout(pollServer, interval));
  }

  return { content, loading, taskPoll };
}
